import { initContract } from '@ts-rest/core';
import { authContract } from './auth';
import { reportsContract } from './reports';
import { employeesContract } from './employees';
import { verificationsContract } from './verifications';
import { scoresContract } from './scores';
import { settingsContract } from './settings';
import { flagsContract } from './flags';
import { healthContract } from './health';
import { collectionContract } from './collection';
const c = initContract();
export const apiContract = c.router({
    auth: authContract,
    reports: reportsContract,
    employees: employeesContract,
    verifications: verificationsContract,
    scores: scoresContract,
    settings: settingsContract,
    flags: flagsContract,
    health: healthContract,
    collection: collectionContract,
}, {
    pathPrefix: '/api/v1',
});
export { authContract, reportsContract, employeesContract, verificationsContract, scoresContract, settingsContract, flagsContract, healthContract, collectionContract, };
export * from './schemas';
//# sourceMappingURL=index.js.map